import React, { useEffect, useState, useImperativeHandle, forwardRef, useContext } from 'react';
import { Modal, Divider, Header, Icon, Button } from 'semantic-ui-react';
import { fetch } from 'services/http';
import { arrayChunk } from 'utils';
import Checkbox from '@material-ui/core/Checkbox';
import produce from 'immer';
import './styles.scss';
import { Popover, FormControlLabel } from '@material-ui/core';
import { toast } from 'react-toastify';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { ConfCuponsStateContext, ConfCuponsDispatchContext } from './ConfCuponsContext';

const PaymentTypesLabelComponent = ({ selectedPaymentTypes }) => {
    const label = {
        163: 'NP',
        177: 'CF',
        9611: 'CTF',
        47357: 'VC',
        53931954: 'PF',
    };
    return selectedPaymentTypes.map((it) => label[it] ? <span className={`payment-type-label ${label[it].toLowerCase()}`}>{label[it]}</span> : null);
};

const ProfileModalComponent = forwardRef((props, ref) => {
    const state = useContext(ConfCuponsStateContext);
    const dispatch = useContext(ConfCuponsDispatchContext);
    const [open, setOpen] = useState(false);
    const [companies, setCompanies] = useState([]);

    useImperativeHandle(ref, () => ({
        open() {
            setOpen(true);
        },
        close() {
            setOpen(false);
        }
    }));

    useEffect(() => {
        (async () => {
            const getPaymentTypes = fetch('/common/payment-types').then(res => res.json());
            const getCompanies = fetch('/common/empresas').then(res => res.json());
            const [paymentTypes, companies] = await Promise.all([getPaymentTypes, getCompanies]);

            const data = companies.empresas
                .filter((it) => it.tipo === 'POSTO')
                .map((it) => ({
                    id: it._id,
                    name: !['DP 1', 'DP 2', 'DP 99'].includes(it.nomeEmpresa) ? it.nomeEmpresa.replace('DP ', '') : it.nomeEmpresa,
                    paymentTypes: paymentTypes.map((it) => ({ ...it, checked: false })),
                    checked: false,
                }));

                if (state.profile) {
                    for (const companyId in state.profile) {
                        const company = data.find((it) => it.id === Number(companyId));
                        if (company) {
                            company.checked = true;

                            for (const payment of company.paymentTypes) {
                                if (state.profile[companyId].indexOf(payment.id) !== -1) {
                                    payment.checked = true;
                                }
                            }
                        }
                    }
                }
            setCompanies(data);
        })();
    }, [state.profile]);

    const handleCompanyChecked = (companyId) => (_, checked) => {
        setCompanies(
            produce(companies, (draft) => {
                const companyIndex = draft.findIndex((it) => it.id === companyId);
                draft[companyIndex].checked = checked;
                draft[companyIndex].paymentTypes.forEach((payment) => {
                    payment.checked = checked;
                });
            }),
        );
    };

    const handlePaymentTypeChecked = (companyId) => (event, checked) => {
        const paymentTypeId = Number(event.target.value);
        setCompanies(
            produce(companies, (draft) => {
                const companyIndex = draft.findIndex((it) => it.id === Number(companyId));
                const paymentTypeIndex = draft[companyIndex].paymentTypes.findIndex((it) => it.id === paymentTypeId);
                draft[companyIndex].paymentTypes[paymentTypeIndex].checked = checked;
                const havePaymentTypeChecked = Boolean(draft[companyIndex].paymentTypes.find((it) => it.checked));
                draft[companyIndex].checked = havePaymentTypeChecked;
            })
        );
    };

    const handleSave = () => {
        // setSaveButton((prevState) => ({ ...prevState, loading: true, disabled: true }));
        const data = {};
        companies.filter((it) => it.checked)
            .forEach((company) =>
                data[company.id] = company.paymentTypes
                .filter((payment) => payment.checked)
                .map((payment) => payment.id));

        fetch('/control-docs/profile', {
            method: 'POST',
            body: JSON.stringify({
                data,
                active: state.active !== null ? Number(state.active) : undefined,
            }),
            headers: { 'Content-Type': 'application/json' }
        })
        .then((response) => response.json())
        .then((result) => {
            if (result) {
                dispatch({ type: 'UPDATE_PROFILE', payload: data });
                toast.success('Pefil alterado com sucesso.');
                ref.current.close();
            } else {
                toast.error('Erro ao alterar perfil.');
            }
            // setSaveButton((prevState) => ({ ...prevState, loading: false, disabled: false }));
        })
        .catch((err) => {
            console.dir(err);
        });
    };

    const handleToggleProfile = (_, checked) => {
        dispatch({ type: 'UPDATE_PROFILE_STATUS', payload: checked });
    };

    return (
        <Modal open={open} onClose={() => setOpen(false)} size="large">
            <Modal.Content>
                <Divider className="mt-5" horizontal>
                    <Header as='h4'>
                        <Icon name='building' />
                        Unidades
                    </Header>
                </Divider>
                <div style={{ display: 'block', marginBottom: 15 }}>
                    <div style={{ float: 'left' }}>
                        <span>
                            <b>{companies.filter((c) => c.checked).length}</b>
                            {' '}unidades selecionada(s)</span>
                        <span style={{ marginLeft: 15 }}>
                            <b>{companies.map((c) => c.paymentTypes.filter((p) => p.checked).length).reduce((a, b) => a + b, 0)}</b>
                            {' '}conferência(s) selecionada(s)
                        </span>
                    </div>
                    <div style={{ float: 'right', marginTop: -10 }}>
                        <FormControlLabel
                            label={<span style={{ fontWeight: 'bold', color: 'green', marginRight: 15 }}>PERFIL ATIVO</span>}
                            control={
                                <Checkbox
                                    onChange={handleToggleProfile}
                                    checked={state.active}
                                    color="primary"
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                />}
                            />
                    </div>
                </div>
                <div style={{ display: 'flex', clear: 'both' }}>
                    {arrayChunk(companies, companies.length / 3).map((chunk, i) => (
                        <div className="ml-5" key={i}>
                            {chunk.map((company, j) => (
                                <PopupState variant="popover" popupId={`popup-id-${i}-${j}`} key={`popup-state-${i}-${j}`}>
                                    {(popupState) => (
                                        <div style={{ margin: 0 }} key={`popup-${i}-${j}`}>
                                            <Checkbox
                                                color="primary"
                                                onChange={handleCompanyChecked(company.id)}
                                                checked={company.checked}
                                                style={{ padding: 5 }}
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                            <span {...bindTrigger(popupState)} className='company'>{company.name}</span>
                                            <PaymentTypesLabelComponent selectedPaymentTypes={company.paymentTypes.filter((it) => it.checked).map((it) => it.id)} />

                                            <Popover
                                                {...bindPopover(popupState)}
                                                id="payment-types-popover"
                                                anchorOrigin={{
                                                    vertical: 'center',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'center',
                                                    horizontal: 'left',
                                                }}
                                                style={{
                                                    padding: 12,
                                                    marginLeft: 12,
                                                }}
                                            >
                                                {company.paymentTypes.map((paymentType) => (
                                                    <>
                                                        <div>
                                                            <Checkbox
                                                                checked={paymentType.checked}
                                                                color="primary"
                                                                onChange={handlePaymentTypeChecked(company.id)}
                                                                value={paymentType.id}
                                                                style={{ padding: 5 }}
                                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                            />
                                                            <span>{paymentType.nome}</span>
                                                        </div>
                                                    </>
                                                ))}
                                            </Popover>
                                        </div>
                                    )}
                                </PopupState>
                            ))}
                        </div>
                    ))}
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    type="button"
                    color="green"
                    onClick={handleSave}
                // disabled={saveButton.disabled}
                // loading={saveButton.loading}
                >
                    <Icon name="save outline" /> Salvar
                </Button>
            </Modal.Actions>
        </Modal>
    );
});
export const ProfileModal = React.memo(ProfileModalComponent);
